import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import PasswordReset from "@/pages/PasswordReset";
import Register from "@/pages/Register";
import RiderHome from "@/pages/RiderHome";
import DriverMode from "@/pages/DriverMode";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPeople from "@/pages/admin/AdminPeople";
import AdminDrivers from "@/pages/admin/AdminDrivers";
import AdminAudit from "@/pages/admin/AdminAudit";
import QuickBook from "@/pages/admin/QuickBook";
import AdminRides from "@/pages/admin/AdminRideHistory";
import AdminDirectory from "@/pages/admin/AdminDirectory";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminCredit from "@/pages/admin/AdminCredit";
import { AdminLive, AdminMessages, AdminNotifications } from "@/pages/admin/AdminComms";
import AdminPromotions from "@/pages/admin/AdminPromotions";
import { AdminAnnouncements, AdminAssignments, AdminPastRides, AdminReports, AdminSettings } from "@/pages/admin/AdminTools";
import TrackRide from "@/pages/TrackRide";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<PasswordReset />} />
            <Route path="/reset-password" element={<PasswordReset />} />
            <Route path="/register" element={<Register />} />
            <Route path="/track/:token" element={<TrackRide />} />
            <Route path="/ride" element={<ProtectedRoute mode="rider"><RiderHome /></ProtectedRoute>} />
            <Route path="/drive" element={<ProtectedRoute mode="driver"><DriverMode /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute mode="admin"><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="book" element={<QuickBook />} />
              <Route path="rides/:rideId/edit" element={<QuickBook />} />
              <Route path="users" element={<AdminPeople />} />
              <Route path="drivers" element={<AdminDrivers />} />
              <Route path="audit" element={<AdminAudit />} />
              <Route path="rides" element={<AdminRides />} />
              <Route path="directory" element={<AdminDirectory />} />
              <Route path="pricing" element={<AdminPricing />} />
              <Route path="discounts" element={<AdminDiscounts />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="credit" element={<AdminCredit />} />
              <Route path="live" element={<AdminLive />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="notifications" element={<AdminNotifications />} />
              <Route path="promotions" element={<AdminPromotions />} />
              <Route path="announcements" element={<AdminAnnouncements />} />
              <Route path="assignments" element={<AdminAssignments />} />
              <Route path="past-rides" element={<AdminPastRides />} />
              <Route path="reports" element={<AdminReports />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
